interface HeroProps {
  scrollToSection: (id: string) => void;
}

export default function Hero({ scrollToSection }: HeroProps) {
  return (
    <section id="home" className="relative h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 w-full h-full">
        <img 
          src="https://public.readdy.ai/ai/img_res/6cf90f86744366818707c5a54cc772c7.jpg"
          alt="AI Vending Machine"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 w-full">
        <div className="max-w-3xl">
          <div className="inline-block mb-6 px-5 py-2 rounded-full border-2 border-white/40 backdrop-blur-sm">
            <span className="text-white text-sm font-medium">AI-Powered Solutions</span>
          </div>
          
          <h1 className="text-7xl font-light text-white mb-6 leading-tight" style={{ fontFamily: 'Playfair Display, serif', letterSpacing: '-1px' }}>
            Smart Vending<br />
            Machines for New Jersey
          </h1>
          
          <p className="text-2xl text-white/90 mb-10 font-light">
            Unattended, intelligent, and always available
          </p>

          {/* Free badges */}
          <div className="flex flex-wrap gap-3 mb-10">
            <span className="inline-flex items-center gap-2 bg-teal-600/90 backdrop-blur-sm text-white px-5 py-2 rounded-full text-sm font-semibold">
              <i className="ri-gift-line"></i> 100% Free to You — No Cost Ever
            </span>
            <span className="inline-flex items-center gap-2 bg-amber-700/90 backdrop-blur-sm text-white px-5 py-2 rounded-full text-sm font-semibold">
              <i className="ri-tools-line"></i> Maintenance-Free
            </span>
            <span className="inline-flex items-center gap-2 bg-white/20 backdrop-blur-sm text-white px-5 py-2 rounded-full text-sm font-semibold">
              <i className="ri-refresh-line"></i> Regularly Restocked
            </span>
          </div>
          
          <button 
            onClick={() => scrollToSection('services')}
            className="bg-amber-900 text-white px-10 py-4 rounded-full text-lg font-medium hover:bg-amber-800 transition-all hover:scale-105 whitespace-nowrap cursor-pointer inline-flex items-center gap-2"
          >
            Explore Our Solutions
            <i className="ri-arrow-right-line"></i>
          </button>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-white text-2xl"></i>
      </div>
    </section>
  );
}